module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.8.1-140.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.8.1.md
// module id = 557
// module chunks = 231